import fetchApi, { BaseReq, request } from './fetch-api';

export interface Counterparty {
  readonly id: number;
  readonly firm: string;
  readonly ticker: string;
  readonly color: string;
  readonly is_favorite: boolean;
  readonly is_liquidity_provider: boolean;
}

export interface ListApprovedCounterpartiesReq extends BaseReq {
  readonly search?: string;
  readonly product?: string;
}

interface SetCounterpartyFavoritismReq extends BaseReq {
  readonly id: number;
  readonly isFavorite: boolean;
}

export async function setCounterpartyFavoritism(
  req: SetCounterpartyFavoritismReq,
) {
  const { id, isFavorite, ...rest } = req;
  return request<null>({
    ...rest,
    method: isFavorite ? 'PATCH' : 'DELETE',
    url: `/trading-desk/member/favorite-counterparty/${id}/`,
  });
}

export const updateFavoritesCounterpartiesApi = async (id: number) =>
  fetchApi.once('patch', `/trading-desk/member/favorite-counterparty/${id}/`);

export const deleteFavoritesCounterpartiesApi = async (id: number) =>
  fetchApi.once('delete', `/trading-desk/member/favorite-counterparty/${id}/`);
